module.exports = __webpack_public_path__ + "img/close-2.d985d7cc.svg";